import { Receipt as OrderIcon } from "@phosphor-icons/react"

export default OrderIcon
